import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventosComponent } from 'src/app/modulos/eventos/eventos.component';
import { PartialModule } from '../../partial/partial.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EventoItemComponent } from 'src/app/components/evento/evento-item/evento-item.component';
import { PipeModule } from '../../pipe/pipe.module';


@NgModule({
  declarations: [
    EventosComponent,
    EventoItemComponent
  ],
  exports: [
    EventosComponent,
    EventoItemComponent
  ],
  imports: [
    CommonModule,
    PartialModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule
  ]
})
export class ModuloEventosModule { }
